module.exports = __webpack_public_path__ + "static/media/documents icon.1b1806d8.svg";